import { ProxyCourseResponse } from "../types/api-responses.js";
import { localStorage } from "./localstorage.js";

export const courseStorage = localStorage<ProxyCourseResponse>("course");
export const courseCacheExpireDate = localStorage<number>("course_expire_date");
export const isAdminStorage = localStorage<boolean>("is_admin");
